import styled from 'styled-components';

const SeverityBlock = styled.span`
  background: ${(props) => props.background};
  padding: 2px 8px;
  font-weight: 500;
  color: white;
  border-radius: 4px;
  text-transform: uppercase;
  font-size: 12px;
`;

export default SeverityBlock;
